var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "trait" } },
    [
      _c("banner-content"),
      _c(
        "ul",
        { staticClass: "trait-list" },
        _vm._l(_vm.traitList, function(item, i) {
          return _c("li", { key: i, attrs: { title: item.title } }, [
            _c("img", { attrs: { src: item.img, alt: item.title } }),
            _c("h1", [_vm._v(_vm._s(item.title))]),
            _c("p", [_vm._v(_vm._s(item.describe))])
          ])
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37fb6d28", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37fb6d28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/trait/index.vue
// module id = NKEU
// module chunks = 20